module.exports = __webpack_public_path__ + "img/fort-farizon.f5c1fb35.jpg";